import { Iconic } from '@/commons/iconic';
import { translates } from '@/utils';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';

type PropsModalDivider = {
  product: string;
  quantityP: number;
  open: boolean;
  handleClose: () => void;
  handleDividerItem: (quantity: number) => void;
};

export const ModalDividerItem = ({
  product,
  quantityP,
  handleClose,
  open,
  handleDividerItem,
}: PropsModalDivider) => {
  const [quantity, setQuantity] = useState(0);

  useEffect(() => {
    setQuantity(quantityP);
  }, [open, quantityP]);

  const handleChangeQuantity = (e: any) => {
    const { value } = e.target;
    if (value <= quantityP && value > 0) {
      setQuantity(value);
    }
  };

  const handleChangeQuantityClick = (flag: boolean) => {
    const value = flag ? quantity + 1 : quantity - 1;
    if (value <= quantityP && value > 0) {
      setQuantity((prev) => (flag ? prev + 1 : prev - 1));
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle textAlign="center">{translates.orderItem}</DialogTitle>
      <DialogContent
        sx={{
          width: '19rem',
          display: 'flex',
          gap: '0.5rem',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Stack justifyItems="center" alignItems="center">
          <Typography variant="h5">{translates.product}</Typography>
          <Typography> {product} </Typography>
        </Stack>
        <Stack justifyItems="center" alignItems="center">
          <Typography variant="h5">{translates.quantity}</Typography>

          <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
            <IconButton onClick={() => handleChangeQuantityClick(false)}>
              <Iconic icon="eva:minus-fill" />
            </IconButton>
            <TextField
              sx={{ width: '1rem', textAlign: 'center' }}
              value={quantity}
              type="number"
              size="small"
              variant="standard"
              onChange={handleChangeQuantity}
            />
            <IconButton onClick={() => handleChangeQuantityClick(true)}>
              <Iconic icon="eva:plus-fill" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button onClick={() => handleDividerItem(quantity)}>{translates.divider}</Button>
        <Button onClick={handleClose}>{translates.cancel}</Button>
      </DialogActions>
    </Dialog>
  );
};
